import { render, staticRenderFns } from "./ComisionTipoAtencion.vue?vue&type=template&id=5fc16260"
import script from "./ComisionTipoAtencion.vue?vue&type=script&lang=ts"
export * from "./ComisionTipoAtencion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports